import { outboundReferralBaseModel } from './crud';

export * from './types';

export const useOutboundReferralsByIdV2 =
  outboundReferralBaseModel.fetchByIdV2();
export const useOutboundReferralsByIdsV2 =
  outboundReferralBaseModel.fetchByIdsV2();
export const useOutboundReferralsManyV2 =
  outboundReferralBaseModel.fetchManyV2();
export const useOutboundReferralsCountV2 = outboundReferralBaseModel.countV2();
export const useOutboundReferralsUpdateOneV2 =
  outboundReferralBaseModel.editV2();
export const useOutboundReferralsCreateOneV2 =
  outboundReferralBaseModel.createV2();
export const useOutboundReferralsRemoveOneV2 =
  outboundReferralBaseModel.deleteV2();
export const useOutboundReferralsRemoveByIdsV2 =
  outboundReferralBaseModel.deleteByIdsV2();

export const useOutboundReferralByIdV2 =
  outboundReferralBaseModel.fetchByIdV2();
export const useOutboundReferralByIdsV2 =
  outboundReferralBaseModel.fetchByIdsV2();
export const useOutboundReferralManyV2 =
  outboundReferralBaseModel.fetchManyV2();
export const useOutboundReferralCountV2 = outboundReferralBaseModel.countV2();
export const useOutboundReferralUpdateOneV2 =
  outboundReferralBaseModel.editV2();
export const useOutboundReferralCreateOneV2 =
  outboundReferralBaseModel.createV2();
export const useOutboundReferralRemoveOneV2 =
  outboundReferralBaseModel.deleteV2();
export const useOutboundReferralRemoveByIdsV2 =
  outboundReferralBaseModel.deleteByIdsV2();
